<template>
  <div>
    <el-row :gutter="20">
    <div style="margin: 30px auto;">
      <el-alert
    title="*比对微信/支付宝的话,先点击1.写入数据,2.数据比对导出,如果导出时间太长无反应,可以过2分钟后刷新页面,点[历史下载]下载比对文件"
    type="error"> </el-alert>
    </div>
 
        <el-col :span="3">
              <el-select v-model="type" size="mini" placeholder="请选择">
                <el-option
                  v-for="item in typeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="3">
            <div>
                <el-upload class="fl" style="margin-right: 10px" action="" :on-change="uploadHandleChange" :auto-upload="false" :show-file-list="false" >
                    <el-button   size="mini" type="primary">点击上传</el-button>
                </el-upload>
            </div>
        </el-col>
        </el-row>
        <div>
          <el-card>
            选择日期
                   <el-date-picker
                   size="mini"
                     v-model="times"
                     type="daterange"
                     range-separator="至"
                     start-placeholder="开始日期"
                     end-placeholder="结束日期">
                   </el-date-picker>
          </el-card>
          <el-card >
              <template>
                <el-table :data="dataArr" >
                  <el-table-column
                    prop="create_time"
                    label="日期">
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    label="历史下载">
                     <template slot-scope="scope">
                        <el-button v-if="scope.row.history !=undefined && scope.row.history.length>0" size="mini" @click="download(scope.row.history)" type="danger">下载</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作">
                     <template slot-scope="scope">
                        <el-button size="mini" @click="insert(scope.row.type)" type="danger">1.写入数据</el-button>
                        <el-button size="mini" @click="checkFile(scope.row.type)" type="primary">2.数据比对导出</el-button>
                        <el-button size="mini" @click="del(scope.row.type,scope.$index)" type="danger">移除X</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
          </el-card>
        </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { handleUploadFile,getPayTypeList,checkFileSubmit,removeFileRow,getCheckFileList,checkInsert} from '../../../api/trade'
  export default {
    data () {
      return {
        loading: false,
        form: {},
        typeArr:[],
        type:'',
        times:'',
        dialogVisible:false,
        dataArr:[],
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      uploadHandleChange (file, fileList) {
       const loading = this.$loading({
                lock: true,
                text: '正在上传,请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
        let params = {isUploadFile: true, file:file.raw,type:this.type,times:this.times}
        handleUploadFile(params).then(response => {
           loading.close();
          this.$message({
            type: 'success',
            message: '上传成功，等待处理'
          })
            this.getDataList();
        })
      },
      getTypeList()
      {
        getPayTypeList().then(response => {
            this.typeArr = response.data.data
        })
      },
      getDataList()
      {
        getCheckFileList().then(response => {
            this.dataArr = response.data.data
        })
      },
      insert(type)
      {
        const loading = this.$loading({
                 lock: true,
                 text: '正在执行请稍后...',
                 spinner: 'el-icon-loading',
                 background: 'rgba(0, 0, 0, 0.7)'
               });
        checkInsert({type:type}).then(response => {
          loading.close();
            this.$message({
              type: 'success',
              message: response.data.data.msg
            })
        })
      },
      checkFile(type)
      {
        const loading = this.$loading({
                 lock: true,
                 text: '正在执行请稍后...',
                 spinner: 'el-icon-loading',
                 background: 'rgba(0, 0, 0, 0.7)'
               });
        checkFileSubmit({type:type,times:this.times}).then(response => {
              if (response.data.data.status) {
                loading.close();
                  this.$message({
                      title: '成功',
                      message: response.data.data.msg,
                      type: 'success'
                  })
                  var url = response.data.data.url
                  // window.open(url)
              } else {
                  this.$notify({
                      title: '失败',
                      message:  response.data.data.msg,
                      type: 'error'
                  })
              }
        })
      },
      del(type,index)
      {
        removeFileRow({type:type}).then(response => {
             this.$message({
               type: 'success',
               message: '已移除'
             })
              this.dataArr.splice(index,1);
              //this.getDataList();

        })

      },
      download(list){
        var last = list.pop();
        window.open(last.url)
      }
    },

    mounted () {
      this.getTypeList();
      this.getDataList();
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// checkorder.vue?bf775d5e